'use client';

import { createContext } from 'react';

export type NavigationGuard = {
  /** Whether SPA navigation should be intercepted right now (consulted at click time). */
  shouldBlock: () => boolean;
  /**
   * Called with the intended href when a navigation was intercepted. The guard
   * owns the confirm UX and performs the navigation itself if the user proceeds.
   */
  onBlocked: (destination: string) => void;
};

export type NavigationGuardContextValue = {
  /** Register a guard; returns an unregister function. */
  registerGuard: (guard: NavigationGuard) => () => void;
  /**
   * Consulted by nav links inside next/link's onNavigate. Returns true when the
   * navigation was intercepted, in which case the caller must preventDefault.
   */
  interceptNavigation: (href: string) => boolean;
};

export const NavigationGuardContext = createContext<NavigationGuardContextValue | null>(null);
